module.exports = __webpack_public_path__ + "static/media/home-main.a7c257db.png";